import { setLocalePath } from "@/locales/index";
export const locale_file_path = "views.worker_allocate.";
/**
 * 언어팩 경로 셋팅 메서드
 * @param appendPath 추가로 붙일 경로 문자열
 * @returns
 */
export const initAutoLc = (appendPath = "") => setLocalePath(locale_file_path + appendPath);
export default {
    header: {
        title: "@:{'resource.order.delivery_charge'}",
    },
    required_message: "주문 아이디 또는 총판 아이디는 필수 입니다.",
    // 라이더 테이블
    worker_list_table_header: {
        hub_name: "허브명",
        worker_code: "라이더 코드",
        worker_number: "라이더 사번",
        worker_name: "라이더명",
        status: "상태",
        mobile_number: "단말기",
        contact: "연락처",
        location: "위치",
        distance_customer: "고객과거리",
        distance_store: "가맹점과거리",
        distance: "거리",
        pickup_expected_at: "픽업예정시각",
        block: "차단여부",
    },
    // 수행상황 테이블
    worker_order_list_table_header: {
        order_id: "주문아이디",
        status_code: "오더상태",
        elapsed_time: "경과시간",
        remaining_time: "남은시간",
        allocated_time: "배차시각",
        pickup_expected_at: "픽업예정시각",
        store_address: "출발지",
        drop_address: "도착지",
    },
};
